import React, { useState, useEffect } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';
import { Spin } from 'antd';
import create from '@ant-design/icons/lib/components/IconFont';


const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

 const [amount, setAmount] = useState(100);
    // const backendUrl = "http://localhost:5000";

const createOrder = async () => {
    try {
        const response = await api.post('/create-order', { amount });
        
        window.location.href = response.data.checkoutPageUrl;
  
    }
    catch (error) {
        console.error("Error in createOrder:", error);
    }
}

  return (
    <div className="home-page">
      <Helmet>
        <title>Pay Now - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
          <section className="breadcrumb_area breadcrumb2 bgimage biz_overlay">
        <div className="bg_image_holder" style={{backgroundImage: 'url("img/breadbg.jpg")', opacity: 1, backgroundImage: 'linear-gradient(to right, #413AA4, rgb(16 139 255))'}}>
          <img src="img/breadbg.jpg" alt="img/breadbg.jpg" />
        </div>
        <div className="container content_above">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                <h4 className="page_title">Privacy Policy</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb m-bottom-30">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-5">
                <div className="divider divider-simple text-center">
                  <h3>Privacy Policy</h3>
                </div>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-12">
                <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
                <h2 className="text-2xl font-bold mb-4">Make a Payment</h2>
                <input
                    type="number"
                    className="border rounded p-2 mb-4 w-full"
                    value={12}
                    onChange={(e) => setAmount(e.target.value * 100) }
                
                    min="1"
                />
                <button
                onClick={createOrder}
                 
                    className="bt btn-primary"
                >
                    Pay Now
                </button>
            </div>
        </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;